export function Footer() {
    return (
        <footer aria-label="footer">
            <p>Cristian Martí | Xmas challenge | ISDI Coders</p>
        </footer>
    );
}
